module.exports = __webpack_public_path__ + "static/img/zhuanzheng.bb3a8cfd.png";